// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__161Xb","colBig":"styles_colBig__2taZP","colSmall":"styles_colSmall__1m3Tx","shopifyNameWrapper":"styles_shopifyNameWrapper__3RAq9"};